import React, { useState, useEffect, useRef, useContext } from "react";
import { UserInformationContext, ReferenceDataContext, EventContext, INIT_STATUS_COMPLETED } from "./App";
import { C4FStatusContext } from "./App";
import { InfoModalContext } from "./App";
import { Button, ButtonGroup, Container, Row, Col, InputGroup, Form, Table, Dropdown, DropdownButton } from 'react-bootstrap';
import '../css/general.css';
import config from "../etc/config.json";
import SkillClimbing from "../img/icons/skill-climbing.png";
import SkillFlat from "../img/icons/skill-flat.png";
import SkillDownhill from "../img/icons/skill-downhill.png";
import SkillTimeTrial from "../img/icons/skill-timetrial.png";
import SkillSprint from "../img/icons/skill-sprint.png";
import SkillCobbles from "../img/icons/skill-cobbles.png";
import SkillRegeneration from "../img/icons/skill-regeneration.png";
import C4FSimpleTable from "../common/C4FSimpleTable";
import { getJersey } from "../race/C4FLeaderJerseys";
import { getC4FCodeForCountryCode, getCountryName, getUnicodeFlag, getRegularTeam, getNationalTeamSelectionTime, isReadyForSelection, formatLocalDateTime, currentYear } from "../common/Helpers";

function Statistics(props) {

  const { userInformation } = useContext(UserInformationContext);
  const { initialized, handleBackendRequest, browserInfo } = useContext(C4FStatusContext);
  const { showTeamInfo, showRiderInfo } = useContext(InfoModalContext);
  const { divisions, countries } = useContext(ReferenceDataContext);
  const { events } = useContext(EventContext);
  const [ridersStatistics, setRidersStatistics] = useState([]);
  const [ridersStatisticsComplete, setRidersStatisticsComplete] = useState(false);
  const [ridersStatisticsInfo, setRidersStatisticsInfo] = useState(null);
  const [exRidersStatistics, setExRidersStatistics] = useState([]);
  const [exRidersStatisticsComplete, setExRidersStatisticsComplete] = useState(false);
  const [exRidersStatisticsInfo, setExRidersStatisticsInfo] = useState(null);
  const [teamsStatistics, setTeamsStatistics] = useState([]);
  const [teamsStatisticsComplete, setTeamsStatisticsComplete] = useState(false);
  const [teamsStatisticsInfo, setTeamsStatisticsInfo] = useState(null);
  const [usersStatistics, setUsersStatistics] = useState([]);
  const [usersStatisticsComplete, setUsersStatisticsComplete] = useState(false);
  const [usersStatisticsInfo, setUsersStatisticsInfo] = useState(null);
  const [transfers, setTransfers] = useState([]);
  const [transfersComplete, setTransfersComplete] = useState(false);
  const [transfersInfo, setTransfersInfo] = useState(null);
  const [divisionData, setDivisionData] = useState([]);
  const [hallOfFame, setHallOfFame] = useState([]);
  const [hofTeamStatistics, setHofTeamStatistics] = useState([]);
  const [countryStatistics, setCountryStatistics] = useState([]);
  const [splitStats, setSplitStats] = useState([]);
  const [splitStatsScope, setSplitStatsScope] = useState('Teams');
  const [splitStatsType, setSplitStatsType] = useState('Wins');
  const [raceSeriesList, setRaceSeriesList] = useState([]);
  const [raceSeriesResultList, setRaceSeriesResultList] = useState([]);
  const [raceSeriesRiderResults, setRaceSeriesRiderResults] = useState([]);
  const [raceSeriesTeamResults, setRaceSeriesTeamResults] = useState([]);
  const [raceSeries, setRaceSeries] = useState(null);
  const [raceSeriesRules, setRaceSeriesRules] = useState([]);
  const [selectedRaceSeries, setSelectedRaceSeries] = useState(null);

  const [tab, setTab] = useState(null);
  const [subTab, setSubTab] = useState('riderRanking');
  const [dateFrom, setDateFrom] = useState(currentYear + '-01-01');
  const [dateTo, setDateTo] = useState(currentYear + '-12-31');
  const [selectedDivision, setSelectedDivision] = useState(1);
  const mounted = useRef(false);

  function getInterfaceText(type, source) {
    if (type === 'raceSeriesRulesResultType') {
      if (source === 'stage') return 'Race Result';
      if (source === 'stageRace') return 'Tour Result';
      else return source;
    }
  }

  function handleMainTab(tab) {
    if (tab === 'riders') {
      if (ridersStatistics.length === 0) {
        loadStatistics('riders', 200);
      }
      setSubTab('riderRanking');
    }
    else if (tab === 'exRiders') {
      if (exRidersStatistics.length === 0) {
        loadStatistics('exRiders', 200);
      }
      setSubTab('riderRanking');
    }
    else if (tab === 'teams') {
      if (teamsStatistics.length === 0) {
        loadStatistics('teams', 200);
      }
    }
    else if (tab === 'users') {
      if (usersStatistics.length === 0) {
        loadStatistics('users', 200);
      }
    }
    else if (tab === 'divisions') {
      if (divisionData.length === 0) {
        loadStatistics('divisions');
      }
    }
    else if (tab === 'countries') {
      if (countryStatistics.length === 0) {
        loadStatistics('countries');
      }
    }
    else if (tab === 'hallOfFame') {
      if (hallOfFame.length === 0) {
        loadStatistics('hallOfFame');
      }
      setSubTab('all');
    }
    else if (tab === 'transfers') {
      if (transfers.length === 0) {
        loadStatistics('transfers', 200);
      }
    }
    else if (tab === 'raceSeries') {
      if (raceSeriesList.length === 0) {
        loadRaceSeriesList();
      }
      setSubTab('overview');
    }
    setTab(tab);
  }

  function handleSubTab(subTab) {
    setSubTab(subTab);
  }

  function handleSplitStats(scope, type) {
    if (!splitStats.some(stats => stats.type === scope + type + dateFrom + dateTo)) {

      handleBackendRequest('GET', '/statistics/splitStats' + scope + type, null, { from: dateFrom, to: dateTo },
        function (statistics) {
          setSplitStats(splitStats
            .filter(stats => !stats.type.startsWith(scope + type))
            .concat([{
              type: scope + type + dateFrom + dateTo,
              data: statistics
            }]));
        });
    }

    if (splitStatsScope !== scope) setSplitStatsScope(scope);
    if (splitStatsType !== type) setSplitStatsType(type);
    if (tab !== 'splitStats') setTab('splitStats');
  }

  function loadRaceSeriesList() {
    handleBackendRequest('GET', '/raceSeries', null, null,
      function (statistics) {
        setRaceSeriesList(statistics);
      });
  }

  function loadRaceSeries(raceSeries) {

    handleBackendRequest('GET', '/raceSeries/' + raceSeries.id, null, null,
      function (raceSeriesResponse) {
        let loadedRaceSeries = raceSeriesResponse;
        setRaceSeries(loadedRaceSeries);
        handleBackendRequest('GET', '/raceEdition', null, { raceSeriesId: raceSeries.id, context: 'result' },
          function (raceSeriesResults) {
            processRaceSeriesResult(raceSeriesResults, loadedRaceSeries);
            setSelectedRaceSeries(raceSeries.id);
          });
      });
  }

  function processRaceSeriesResult(raceSeriesResult, raceSeries) {
    let resultList = [];
    let rules = raceSeries.rules;

    raceSeriesResult.forEach(result => {
      let raceEditionId = result.raceEdition.id;
      let raceName = raceSeries.raceSeriesItems.find(item => item.raceEditionId === raceEditionId).raceName;
      let rule = rules.find(rule => rule.ruleId === raceSeries.raceSeriesItems.find(race => race.raceEditionId === raceEditionId).ruleId);
      result.raceResults.forEach(raceResult => raceResult.results.forEach(singleResult => {
        if (rule.ruleItems.some(item => item.resultType === 'stage' && item.position === singleResult.position)) {
          let points = rule.ruleItems.find(item => item.resultType === 'stage' && item.position === singleResult.position).points;
          resultList.push({
            raceEditionId: raceEditionId,
            raceName: raceName + ' (' + raceResult.stageNumber + ')',
            startingTime: result.raceEdition.startingTime,
            resultType: 'Stage',
            position: singleResult.position,
            riderId: singleResult.riderId,
            riderName: singleResult.riderName,
            teamId: singleResult.teamId,
            teamName: singleResult.teamName,
            teamsFinished: singleResult.teamsFinished,
            points: points,
            pointsWeighted: points * (singleResult.teamsFinished - 1) / 10
          });
        }
      }));
      result.stageRaceResults.forEach(stageRaceResult => {
        if (rule.ruleItems.some(item => item.resultType === 'stageRace' && item.position === stageRaceResult.position)) {
          let points = rule.ruleItems.find(item => item.resultType === 'stageRace' && item.position === stageRaceResult.position).points;
          resultList.push({
            raceEditionId: raceEditionId,
            raceName: raceName,
            resultType: 'Tour',
            startingTime: result.raceEdition.startingTime,
            position: stageRaceResult.position,
            riderId: stageRaceResult.riderId,
            riderName: stageRaceResult.riderName,
            teamId: stageRaceResult.teamId,
            teamName: stageRaceResult.teamName,
            teamsFinished: stageRaceResult.teamsFinished,
            points: points,
            pointsWeighted: points * (stageRaceResult.teamsFinished - 1) / 10
          });
        }
      });
      result.classifications.forEach(classification => {

        if (rule.ruleItems.some(item => item.resultType === classification.classificationType)) {
          let points = rule.ruleItems.find(item => item.resultType === classification.classificationType).points;
          resultList.push({
            raceEditionId: raceEditionId,
            raceName: raceName,
            resultType: classification.classificationType,
            startingTime: result.raceEdition.startingTime,
            position: 1,
            riderId: classification.riderId,
            riderName: classification.riderName,
            teamId: classification.teamId,
            teamName: classification.teamName,
            teamsFinished: classification.teamsFinished,
            points: points,
            pointsWeighted: points * (classification.teamsFinished - 1) / 10
          });
        }
      }
      );
      return;
    })
    // create set of riderIds
    let allRiders = new Set();
    let allTeams = new Set();
    resultList.forEach(result => {
      allRiders.add(result.riderId);
      allTeams.add(result.teamId);
    });

    // create array from each record in set
    let riderResults = Array.from(allRiders).map(riderId => ({
      riderId: riderId,
      riderName: resultList.find(result => result.riderId === riderId).riderName,
      teamId: resultList.find(result => result.riderId === riderId).teamId,
      teamName: resultList.find(result => result.riderId === riderId).teamName,
      points: resultList.filter(result => result.riderId === riderId).reduce(function (points, result) { return points + result.points }, 0),
      pointsWeighted: resultList.filter(result => result.riderId === riderId).reduce(function (pointsWeighted, result) { return pointsWeighted + result.pointsWeighted }, 0),
      raceWins: resultList.filter(result => result.riderId === riderId && result.resultType === 'Stage' && result.position === 1).reduce(function (raceWins) { return raceWins + 1 }, 0),
      tourWins: resultList.filter(result => result.riderId === riderId && result.resultType === 'Tour' && result.position === 1).reduce(function (tourWins) { return tourWins + 1 }, 0)
    }))

    // create array from each record in set
    let teamResults = Array.from(allTeams).map(teamId => ({
      teamId: teamId,
      teamName: resultList.find(result => result.teamId === teamId).teamName,
      points: resultList.filter(result => result.teamId === teamId).reduce(function (points, result) { return points + result.points }, 0),
      pointsWeighted: resultList.filter(result => result.teamId === teamId).reduce(function (pointsWeighted, result) { return pointsWeighted + result.pointsWeighted }, 0),
      raceWins: resultList.filter(result => result.teamId === teamId && result.resultType === 'Stage' && result.position === 1).reduce(function (raceWins) { return raceWins + 1 }, 0),
      tourWins: resultList.filter(result => result.teamId === teamId && result.resultType === 'Tour' && result.position === 1).reduce(function (tourWins) { return tourWins + 1 }, 0)
    }))

    setRaceSeriesResultList(resultList);
    setRaceSeriesRiderResults(riderResults);
    setRaceSeriesTeamResults(teamResults);
    let rulesConverted = [];
    raceSeries.rules
      .map(rule =>
        rule.ruleItems.map(item => (
          rulesConverted.push({
            ruleId: rule.ruleId,
            ...item,
            resultType: getInterfaceText('raceSeriesRulesResultType', item.resultType)
          }))));
    setRaceSeriesRules(rulesConverted);
  }

  function loadStatistics(type, pageSize = 0) {

    handleBackendRequest('GET', '/statistics/' + type, null, { pageSize: pageSize },
      function (statistics) {
        if (type === 'riders') {
          setRidersStatistics(statistics);
          if (statistics.length < pageSize || pageSize === 0)
            setRidersStatisticsComplete(true);
          setRidersStatisticsInfo('Loaded ' + statistics.length + ' records');
        }
        if (type === 'exRiders') {
          setExRidersStatistics(statistics);
          if (statistics.length < pageSize || pageSize === 0)
            setExRidersStatisticsComplete(true);
          setExRidersStatisticsInfo('Loaded ' + statistics.length + ' records');
        }
        if (type === 'teams') {
          setTeamsStatistics(statistics);
          if (statistics.length < pageSize || pageSize === 0)
            setTeamsStatisticsComplete(true);
          setTeamsStatisticsInfo('Loaded ' + statistics.length + ' records');
        }
        if (type === 'users') {
          setUsersStatistics(statistics);
          if (statistics.length < pageSize || pageSize === 0)
            setUsersStatisticsComplete(true);
          setUsersStatisticsInfo('Loaded ' + statistics.length + ' records');
        }
        if (type === 'divisions') {
          setDivisionData(statistics);
        }
        if (type === 'transfers') {
          setTransfers(statistics);
          setTransfersInfo('Loaded ' + statistics.length + ' records');
        }
        if (type === 'hallOfFame') {
          setHallOfFame(statistics);
          handleHofTeamStatistics(statistics);
        }
        if (type === 'countries') {
          setCountryStatistics(statistics);
        }
      });

  }

  function handleHofTeamStatistics(hallOfFameResult) {
    if (typeof hallOfFameResult === 'undefined') return;
    let hofTeamStatisticsLocal = [];
    let teamIds = new Set();
    // store all teamIds uniquely
    hallOfFameResult.map(hofEntry => teamIds.add(hofEntry.teamId));

    // calculate Palmarès per team
    Array.from(teamIds).map(id => {
      let teamNames = new Set();
      let giro = 0, tour = 0, vuelta = 0;
      let msr = 0, rvv = 0, pr = 0, lbl = 0, lom = 0;
      hallOfFameResult
        .filter(hofEntry => hofEntry.teamId === id)
        .map(hofEntry => {
          teamNames.add(hofEntry.teamName);
          switch (hofEntry.recurringEventId) {
            case 1: tour++; break;
            case 2: giro++; break;
            case 3: vuelta++; break;
            case 4: msr++; break;
            case 5: rvv++; break;
            case 6: pr++; break;
            case 7: lbl++; break;
            case 8: lom++; break;
          }
        });
      hofTeamStatisticsLocal.push({
        teamId: id,
        teamNames: Array.from(teamNames).join(', '),
        total: giro + tour + vuelta + msr + rvv + pr + lbl + lom,
        totalGTs: giro + tour + vuelta,
        totalMonuments: msr + rvv + pr + lbl + lom,
        giro: giro,
        tour: tour,
        vuelta: vuelta,
        msr: msr,
        rvv: rvv,
        pr: pr,
        lbl: lbl,
        lom: lom
      });
      return null;
    });
    setHofTeamStatistics(hofTeamStatisticsLocal);
  }

  useEffect(() => {
    mounted.current = true;
  }, []);

  useEffect(() => {
    return () => {
      mounted.current = false;
    }
  }, []);

  useEffect(() => {
    handleMainTab('divisions');
  }, []);

  return initialized !== INIT_STATUS_COMPLETED ? null : <div className="container-fluid m-0 p-0 justify-content-center">
    <Row className="justify-content-center my-2">
      <ButtonGroup>
        <Button variant={(tab === 'divisions') ? 'primary' : 'outline-primary'} onClick={() => handleMainTab('divisions')}>Divisions</Button>
        <Button variant={(tab === 'users') ? 'primary' : 'outline-primary'} onClick={() => handleMainTab('users')}>Users</Button>
        <Button variant={(tab === 'teams') ? 'primary' : 'outline-primary'} onClick={() => handleMainTab('teams')}>Teams</Button>
        <Button variant={(tab === 'riders') ? 'primary' : 'outline-primary'} onClick={() => handleMainTab('riders')}>Riders</Button>
        <Button variant={(tab === 'exRiders') ? 'primary' : 'outline-primary'} onClick={() => handleMainTab('exRiders')}>Ex-Riders</Button>
        <Button variant={(tab === 'countries') ? 'primary' : 'outline-primary'} onClick={() => handleMainTab('countries')}>Countries</Button>
        <Button variant={(tab === 'transfers') ? 'primary' : 'outline-primary'} onClick={() => handleMainTab('transfers')}>Transfers</Button>
        <Button variant={(tab === 'hallOfFame') ? 'primary' : 'outline-primary'} onClick={() => handleMainTab('hallOfFame')}>Hall of Fame</Button>
        <Button variant={(tab === 'splitStats') ? 'primary' : 'outline-primary'} onClick={() => handleSplitStats(splitStatsScope, splitStatsType)}>Split Stats</Button>
        <Button variant={(tab === 'raceSeries') ? 'primary' : 'outline-primary'} onClick={() => handleMainTab('raceSeries')}>Race Series</Button>
      </ButtonGroup>
    </Row>
    {(() => {
      if (tab === 'divisions')
        return <Container fluid className="m-0 p-0 justify-content-center">
          <Row className="row d-flex mt-1 p-1 justify-content-center">
            <ButtonGroup>
              {divisions.map((division, index) => (
                <Button variant={selectedDivision === index + 1 ? 'primary' : 'outline-primary'}
                  onClick={() => setSelectedDivision(index + 1)}>{(index + 1) + ' - ' + division.name}</Button>
              ))}
            </ButtonGroup>
          </Row>
          <Row className=" d-flex mt-1 p-1 justify-content-center">
            <Col className=" ml-2 mr-1 my-1 p-0" style={{ minWidth: 400, maxWidth: "80vw" }}>
              <h5>{selectedDivision + ' - ' + divisions[selectedDivision - 1].name}</h5>
              <h6>{divisions[selectedDivision - 1].description}</h6>
            </Col>
          </Row>
          <Row className=" d-flex mt-1 p-1 justify-content-center">
            <Col className="col-8 m-1 p-0" style={{ minWidth: 400, maxWidth: "80vw" }}>
              <Table striped className="mt-0 table-light" size="sm">
                <thead>
                  <th>Teams</th>
                  <th>Promotions</th>
                  <th>Relegations</th>
                  <th>Transfermarket</th>
                  <th>Reset Allowed</th>
                </thead>
                <tbody>
                  <tr>
                    <td>{selectedDivision === divisions.length ? 'unlimited' : divisions[selectedDivision - 1].totalTeams}</td>
                    <td>{selectedDivision > 1 ? divisions[selectedDivision - 2].relegatedTeams : 0}</td>
                    <td>{divisions[selectedDivision - 1].relegatedTeams}</td>
                    <td>{divisions[selectedDivision - 1].transfermarketType === 'UpperDivisions' ? 'Auctions' : 'Lower Division Market'}</td>
                    <td>{divisions[selectedDivision - 1].resetAllowed ? 'Yes' : 'No'}</td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>

          <Row className=" d-flex mt-1 p-1 justify-content-center">
            <Col className=" ml-2 mr-1 my-1 p-0" style={{ minWidth: 400, maxWidth: "80vw" }}>
              <Container className="m-0 p-0" style={{ maxHeight: 800, minWidth: 400, maxWidth: "80vw", overflow: "auto", backgroundColor: 'rgba(245, 250, 255, 1)' }}>
                <Table striped size="sm">
                  <thead>
                    <tr>
                      <th className="th-infotable" scope="col">Rank</th>
                      <th className="th-infotable" scope="col" style={{ textAlign: "left" }}>Team</th>
                      <th className="th-infotable" scope="col">Month Races</th>
                      <th className="th-infotable" scope="col">Season Points</th>
                      <th className="th-infotable" scope="col">Total Races</th>
                      <th className="th-infotable" scope="col">Eternal Points</th>
                      <th className="th-infotable" scope="col">Div1 Wins</th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {divisionData
                      .filter(team => team.division === selectedDivision)
                      .sort(function (a, b) { return b.pointsCurrent - a.pointsCurrent })
                      .map((team, index) => (
                        <tr>
                          {(() => {
                            // mark promoted teams in all divisions except Div 1
                            if (selectedDivision > 1 && index + 1 <= divisions[selectedDivision - 2].relegatedTeams)
                              return <td className="td-infotable" style={{ backgroundColor: "rgba(0, 255, 17, 0.3)" }}><b>{index + 1}</b></td>
                            else if (index + 1 <= divisions[selectedDivision - 1].totalTeams - divisions[selectedDivision - 1].relegatedTeams)
                              return <td className="td-infotable"><b>{index + 1}</b></td>
                            else
                              return <td className="td-infotable" style={{ backgroundColor: "rgba(255, 0, 0, 0.3)" }}><b>{index + 1}</b></td>
                          })()}
                          <td className="td-infotable" style={{ textAlign: "left" }}>
                            <a href="#" onClick={() => showTeamInfo(team)} style={userInformation !== null && team.teamName === userInformation.userName ? { fontWeight: "bold", color: "black" } : { color: "black" }}>{team.teamName}</a>
                          </td>
                          <td className="td-infotable">{team.seasonRaces}</td>
                          <td className="td-infotable"><b>{team.pointsCurrent.toLocaleString("en-EN")}</b></td>
                          <td className="td-infotable">{team.totalRaces.toLocaleString("en-EN")}</td>
                          <td className="td-infotable">{team.pointsEternal.toLocaleString("en-EN")}</td>
                          <td className="td-infotable">{team.championships.toLocaleString("en-EN")}</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Container>
            </Col>
          </Row>
        </Container >
      if (tab === 'exRiders')
        return <div className="container-fluid c4f-stats">
          <div className="row d-flex c4f-stats">
            <div className="col m-0 p-0">
              <h5>Former Riders</h5>
              <p>The table shows all former riders.&nbsp;
                {exRidersStatisticsInfo}.&nbsp;
                {exRidersStatisticsComplete ?
                  null :
                  <>
                    <ButtonGroup>
                      <Button className="py-0" variant="outline-primary" onClick={() => loadStatistics('exRiders', 5000)}>Load 5000 records</Button>
                      <Button className="py-0" variant="outline-primary" onClick={() => loadStatistics('exRiders', 0)}>Load all records</Button>
                    </ButtonGroup>
                    <br />Please keep in mind that loading all records might lead to performance issues on your browser.
                  </>
                }
              </p>
            </div>
          </div>
          <div className="row d-flex c4f-stats">
            {/* {subTab === 'riderRanking' ? */}
            <>
              <C4FSimpleTable key={'exRiders'}
                highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
                highlightCriteriaValue={userInformation !== null ? getRegularTeam(userInformation).teamName : null}
                initialSortingColumn={'pointsEternal'}
                initialSortingAscending={false}
                indexColumn={true}
                data={exRidersStatistics.map(record => ({
                  ...record,
                  flag: getUnicodeFlag(record.nationality),
                  nationalityC4FCode: getC4FCodeForCountryCode(countries, record.nationality),
                  riderName: record.firstNames + String.fromCharCode(160) + record.lastNames,
                  cobblesCalculated: 0.7 * record.skillFlat + 0.3 * record.skillCobbles,
                  pointsPerRace: record.totalRaces === 0 ? 0 : (record.pointsEternal / record.totalRaces)
                }))}
                // sample for predefined filter
                // filters={[{ columnName: 'ownerName', type: 'text', value: 'Alkworld', regex: 'Alkworld', valid: true}]}
                rowMetadata={[
                  browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                    { columnName: 'flag', columnDescription: '\u2691', columnGroup: 'Overview' }
                    :
                    { columnName: 'nationalityC4FCode', columnDescription: '\u2691', columnType: 'flag', columnGroup: 'Overview' },
                  { columnName: 'riderName', columnDescription: 'Rider', columnGroup: 'Overview', cellClickEvent: showRiderInfo },
                  { columnName: 'nickname', columnDescription: 'Nickname', columnGroup: 'Overview' },
                  { columnName: 'teamName', columnDescription: 'Team', columnGroup: 'Overview', cellClickEvent: showTeamInfo },
                  { columnName: 'age', columnDescription: 'Age', columnGroup: 'Overview' },
                  { columnName: 'skillClimbing', columnDescription: 'Climbing', columnHeader: <img src={SkillClimbing} title="Mountain" alt="Climbing" />, columnGroup: 'Skills' },
                  { columnName: 'skillFlat', columnDescription: 'Flat', columnHeader: <img src={SkillFlat} title="Flat" alt="Flat" />, columnGroup: 'Skills' },
                  { columnName: 'skillDownhill', columnDescription: 'Downhill', columnHeader: <img src={SkillDownhill} title="Downhill" alt="Downhill" />, columnGroup: 'Skills' },
                  { columnName: 'skillTimeTrial', columnDescription: 'TimeTrial', columnHeader: <img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" />, columnGroup: 'Skills' },
                  { columnName: 'skillSprint', columnDescription: 'Sprint', columnHeader: <img src={SkillSprint} title="Sprint" alt="Sprint" />, columnGroup: 'Skills' },
                  { columnName: 'cobblesCalculated', columnDescription: 'Cobbles', columnHeader: <img src={SkillCobbles} title="Cobbles" alt="Cobbles" />, columnGroup: 'Skills' },
                  { columnName: 'skillRegeneration', columnDescription: 'Regeneration', columnHeader: <img src={SkillRegeneration} title="Regeneration" alt="Regeneration" />, columnGroup: 'Skills' },
                  { columnName: 'pointsEternal', columnDescription: 'Points \u221E', columnGroup: 'Stats' },
                  { columnName: 'totalRaces', columnDescription: 'Races \u221E', columnGroup: 'Stats' },
                  { columnName: 'pointsPerRace', columnDescription: '\u2300 Points', columnGroup: 'Stats' },
                  { columnName: 'raceWins', columnDescription: '\uD83C\uDFC6', columnGroup: 'Palmarès' },
                  {
                    columnName: 'stageRaceWins',
                    columnDescription: 'Tour Wins',
                    columnHeader: <><img alt="GCLeader" title="Stage Race Wins" src={getJersey('Le Tour', 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} />{'\uD83E\uDD47'}</>,
                    columnGroup: 'Palmarès'
                  },
                  {
                    columnName: 'stageRacePodiums',
                    columnDescription: 'Tour Podiums',
                    columnHeader: <>{'\uD83E\uDD48 \uD83E\uDD49'}</>,
                    columnGroup: 'Palmarès'
                  },
                  {
                    columnName: 'sprintJerseys',
                    columnDescription: 'Sprint Jerseys',
                    columnHeader: <img alt="Sprint" title="Sprint Jerseys" src={getJersey('Le Tour', 'Sprint')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                    columnGroup: 'Palmarès'
                  },
                  {
                    columnName: 'mountainJerseys',
                    columnDescription: 'Mountain Jerseys',
                    columnHeader: <img alt="Mountain" title="Mountain Jerseys" src={getJersey('Le Tour', 'Mountain')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                    columnGroup: 'Palmarès'
                  },
                  {
                    columnName: 'youthJerseys',
                    columnDescription: 'Youth Jerseys',
                    columnHeader: <img alt="Youth" title="Youth Jerseys" src={getJersey('Le Tour', 'Youth')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                    columnGroup: 'Palmarès'
                  }

                ]}
              />
            </>
          </div>
        </div>
      if (tab === 'riders')
        return <div className="container-fluid c4f-stats">
          <div className="row d-flex c4f-stats">
            <div className="col m-0 p-0">
              <h5>Riders</h5>
              <p>The table shows all currently active riders.&nbsp;
                {ridersStatisticsInfo}.&nbsp;
                {ridersStatisticsComplete ?
                  null :
                  <>
                    <ButtonGroup>
                      <Button className="py-0" variant="outline-primary" onClick={() => loadStatistics('riders', 1000)}>Load 1000 records</Button>
                      <Button className="py-0" variant="outline-primary" onClick={() => loadStatistics('riders', 0)}>Load all records</Button>
                    </ButtonGroup>
                    <br />Please keep in mind that loading all records might lead to performance issues on your browser.
                  </>
                }
              </p>
            </div>
          </div>
          <div className="row d-flex c4f-stats">
            <C4FSimpleTable key={'riders'}
              highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
              highlightCriteriaValue={userInformation !== null ? getRegularTeam(userInformation).teamName : null}
              initialSortingColumn={'pointsCurrent'}
              initialSortingAscending={false}
              indexColumn={true}
              data={ridersStatistics.map(record => ({
                ...record,
                flag: getUnicodeFlag(record.nationality),
                nationalityC4FCode: getC4FCodeForCountryCode(countries, record.nationality),
                riderName: record.firstNames + String.fromCharCode(160) + record.lastNames,
                cobblesCalculated: 0.7 * record.skillFlat + 0.3 * record.skillCobbles,
                pointsPerRace: record.pointsEternal / record.totalRaces,
                pointsCurrent: record.pointsCurrentSeason + record.pointsPreviousSeason
              }))}
              rowMetadata={[
                browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                  { columnName: 'flag', columnDescription: '\u2691', columnGroup: 'Overview' }
                  :
                  { columnName: 'nationalityC4FCode', columnDescription: '\u2691', columnType: 'flag', columnGroup: 'Overview' },
                { columnName: 'riderName', columnDescription: 'Rider', columnGroup: 'Overview', cellClickEvent: showRiderInfo },
                { columnName: 'nickname', columnDescription: 'Nickname', columnGroup: 'Overview' },
                { columnName: 'age', columnDescription: 'Age', columnGroup: 'Overview' },
                { columnName: 'teamName', columnDescription: 'Team', cellClickEvent: showTeamInfo, columnGroup: 'Overview' },
                { columnName: 'marketValue', columnDescription: 'Value', columnGroup: 'Overview' },
                { columnName: 'salary', columnDescription: 'Salary', columnGroup: 'Overview' },
                { columnName: 'skillClimbing', columnDescription: 'Climbing', columnHeader: <img src={SkillClimbing} title="Mountain" alt="Climbing" />, columnGroup: 'Skills' },
                { columnName: 'skillFlat', columnDescription: 'Flat', columnHeader: <img src={SkillFlat} title="Flat" alt="Flat" />, columnGroup: 'Skills' },
                { columnName: 'skillDownhill', columnDescription: 'Downhill', columnHeader: <img src={SkillDownhill} title="Downhill" alt="Downhill" />, columnGroup: 'Skills' },
                { columnName: 'skillTimeTrial', columnDescription: 'TimeTrial', columnHeader: <img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" />, columnGroup: 'Skills' },
                { columnName: 'skillSprint', columnDescription: 'Sprint', columnHeader: <img src={SkillSprint} title="Sprint" alt="Sprint" />, columnGroup: 'Skills' },
                { columnName: 'cobblesCalculated', columnDescription: 'Cobbles', columnHeader: <img src={SkillCobbles} title="Cobbles" alt="Cobbles" />, columnGroup: 'Skills' },
                { columnName: 'skillRegeneration', columnDescription: 'Regeneration', columnHeader: <img src={SkillRegeneration} title="Regeneration" alt="Regeneration" />, columnGroup: 'Skills' },
                { columnName: 'pointsCurrent', columnDescription: 'Points', columnGroup: 'Stats' },
                { columnName: 'pointsEternal', columnDescription: 'Points \u221E', columnGroup: 'Stats' },
                { columnName: 'totalRaces', columnDescription: 'Races \u221E', columnGroup: 'Stats' },
                { columnName: 'pointsPerRace', columnDescription: '\u2300 Points', columnGroup: 'Stats' },
                { columnName: 'raceWins', columnDescription: '\uD83C\uDFC6', columnGroup: 'Palmarès' },
                {
                  columnName: 'stageRaceWins',
                  columnDescription: 'Tour Wins',
                  columnHeader: <><img alt="GCLeader" title="Stage Race Wins" src={getJersey('Le Tour', 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} />{'\uD83E\uDD47'}</>,
                  columnGroup: 'Palmarès'
                },
                {
                  columnName: 'stageRacePodiums',
                  columnDescription: 'Tour Podiums',
                  columnHeader: <>{'\uD83E\uDD48 \uD83E\uDD49'}</>,
                  columnGroup: 'Palmarès'
                },
                {
                  columnName: 'sprintJerseys',
                  columnDescription: 'Sprint Jerseys',
                  columnHeader: <img alt="Sprint" title="Sprint Jerseys" src={getJersey('Le Tour', 'Sprint')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                  columnGroup: 'Palmarès'
                },
                {
                  columnName: 'mountainJerseys',
                  columnDescription: 'Mountain Jerseys',
                  columnHeader: <img alt="Mountain" title="Mountain Jerseys" src={getJersey('Le Tour', 'Mountain')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                  columnGroup: 'Palmarès'
                },
                {
                  columnName: 'youthJerseys',
                  columnDescription: 'Youth Jerseys',
                  columnHeader: <img alt="Youth" title="Youth Jerseys" src={getJersey('Le Tour', 'Youth')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                  columnGroup: 'Palmarès'
                }
              ]}
            />
          </div>
        </div>
      if (tab === 'teams')
        return <div className="container-fluid c4f-stats">
          <div className="row d-flex c4f-stats">
            <div className="col m-0 p-0">
              <h5>Teams</h5>
              <p>The table shows all teams.&nbsp;
                {teamsStatisticsInfo}.&nbsp;
                {teamsStatisticsComplete ?
                  null :
                  <>
                    <ButtonGroup>
                      <Button className="py-0" variant="outline-primary" onClick={() => loadStatistics('teams', 1000)}>Load 1000 records</Button>
                      <Button className="py-0" variant="outline-primary" onClick={() => loadStatistics('teams', 0)}>Load all records</Button>
                    </ButtonGroup>
                    <br />Please keep in mind that loading all records might lead to performance issues on your browser.
                  </>
                }
              </p>
            </div>
          </div>
          <div className="row d-flex c4f-stats">
            <C4FSimpleTable key={'teams'}
              highlightCriteriaKey={userInformation !== null ? 'name' : null}
              highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
              initialSortingColumn={'pointsEternal'}
              initialSortingAscending={false}
              indexColumn={true}
              data={teamsStatistics.map(team => ({ ...team, pointsPerRace: team.totalRaces === 0 ? 0 : team.pointsEternal / team.totalRaces }))}
              rowMetadata={[
                { columnName: 'name', columnDescription: 'Team', columnGroup: 'Overview', cellClickEvent: showTeamInfo },
                { columnName: 'acronym', columnDescription: 'Acr.', columnGroup: 'Overview' },
                { columnName: 'division', columnDescription: 'Div', columnGroup: 'Overview' },
                { columnName: 'totalRiders', columnDescription: 'Riders', columnGroup: 'Overview' },
                { columnName: 'avgAge', columnDescription: '\u2300 Age', columnGroup: 'Overview' },
                { columnName: 'pointsCurrent', columnDescription: 'Points', columnGroup: 'Stats' },
                { columnName: 'pointsEternal', columnDescription: '\u221E Points', columnGroup: 'Stats' },
                { columnName: 'totalRaces', columnDescription: '\u221E Races', columnGroup: 'Stats' },
                { columnName: 'pointsPerRace', columnDescription: '\u2300 Points', columnGroup: 'Stats' },
                { columnName: 'avgValue', columnDescription: '\u2300 Value', columnGroup: 'Stats' },
                { columnName: 'totalValue', columnDescription: '\u03A3 Value', columnGroup: 'Stats' },
                { columnName: 'avgSalary', columnDescription: '\u2300 Salary', columnGroup: 'Stats' },
                { columnName: 'avgClimbing', columnDescription: 'Climbing', columnHeader: <img src={SkillClimbing} title="Mountain" alt="Climbing" />, columnGroup: 'Skills' },
                { columnName: 'avgFlat', columnDescription: 'Flat', columnHeader: <img src={SkillFlat} title="Flat" alt="Flat" />, columnGroup: 'Skills' },
                { columnName: 'avgDownhill', columnDescription: 'Downhill', columnHeader: <img src={SkillDownhill} title="Downhill" alt="Downhill" />, columnGroup: 'Skills' },
                { columnName: 'avgTimeTrial', columnDescription: 'TimeTrial', columnHeader: <img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" />, columnGroup: 'Skills' },
                { columnName: 'avgSprint', columnDescription: 'Sprint', columnHeader: <img src={SkillSprint} title="Sprint" alt="Sprint" />, columnGroup: 'Skills' },
                { columnName: 'avgCobbles', columnDescription: 'Cobbles', columnHeader: <img src={SkillCobbles} title="Cobbles" alt="Cobbles" />, columnGroup: 'Skills' },
                { columnName: 'avgRegeneration', columnDescription: 'Regeneration', columnHeader: <img src={SkillRegeneration} title="Regeneration" alt="Regeneration" />, columnGroup: 'Skills' },
                { columnName: 'championships', columnDescription: 'Div1 \uD83C\uDFC6', columnGroup: 'Palmarès' },
                { columnName: 'raceWins', columnDescription: '\uD83C\uDFC6', columnGroup: 'Palmarès' },
                { columnName: 'classicWins', columnDescription: 'Classic \uD83C\uDFC6', columnGroup: 'Palmarès' },
                {
                  columnName: 'stageRaceWins',
                  columnDescription: 'Tour Wins',
                  columnHeader: <><img alt="GCLeader" title="Stage Race Wins" src={getJersey('Le Tour', 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} />{'\uD83E\uDD47'}</>,
                  columnGroup: 'Palmarès'
                },
                {
                  columnName: 'stageRacePodiums',
                  columnDescription: 'Tour Podiums',
                  columnHeader: <>{'\uD83E\uDD48 \uD83E\uDD49'}</>,
                  columnGroup: 'Palmarès'
                },
                {
                  columnName: 'sprintJerseys',
                  columnDescription: 'Sprint Jerseys',
                  columnHeader: <img alt="Sprint" title="Sprint Jerseys" src={getJersey('Le Tour', 'Sprint')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                  columnGroup: 'Palmarès'
                },
                {
                  columnName: 'mountainJerseys', columnDescription: 'Mountain Jerseys', columnHeader: <img alt="Mountain" title="Mountain Jerseys" src={getJersey('Le Tour', 'Mountain')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                  columnGroup: 'Palmarès'
                },
                {
                  columnName: 'youthJerseys', columnDescription: 'Youth Jerseys', columnHeader: <img alt="Youth" title="Youth Jerseys" src={getJersey('Le Tour', 'Youth')} style={{ maxHeight: "18px", marginBottom: 1 }} />,
                  columnGroup: 'Palmarès'
                },
                {
                  columnName: 'teamClassifications', columnDescription: 'Team',
                  columnGroup: 'Palmarès'
                }
              ]}
            />
          </div>
        </div>
      if (tab === 'users')
        return <div className="container-fluid c4f-stats">
          <div className="row d-flex c4f-stats">
            <div className="col m-0 p-0">
              <h5>Users</h5>
              <p>The table shows all users.&nbsp;
                {usersStatisticsInfo}.&nbsp;
                {usersStatisticsComplete ?
                  null :
                  <>
                    <ButtonGroup>
                      <Button className="py-0" variant="outline-primary" onClick={() => loadStatistics('users', 1000)}>Load 1000 records</Button>
                      <Button className="py-0" variant="outline-primary" onClick={() => loadStatistics('users', 0)}>Load all records</Button>
                    </ButtonGroup>
                    <br />Please keep in mind that loading all records might lead to performance issues on your browser.
                  </>
                }
              </p>
            </div>
          </div>

          <div className="row d-flex c4f-stats">
            <C4FSimpleTable key={'users'}
              highlightCriteriaKey={userInformation !== null ? 'name' : null}
              highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
              initialSortingColumn={'pointsEternal'}
              initialSortingAscending={false}
              indexColumn={true}
              data={usersStatistics.map(user => { 
                let roles = [];
                if (user.roleAdmin === 1) roles.push('Admin');
                if (user.roleCalendarPlanner === 1) roles.push('Calendar Planner');
                if (user.roleFairplayCommittee === 1) roles.push('FPC');
                if (user.roleNationsCommittee === 1) roles.push('NC');
                return { 
                  ...user,
                  roles: roles.join(', '),
                  nationalTeamName: user.nationalTeam ? getCountryName(countries, user.nationalTeam) : '',
                  countryFlag: user.country ? getUnicodeFlag(user.country) : '',
                  countryFlagC4FCode: user.country ? getC4FCodeForCountryCode(countries, user.country) : '',
                  nationalTeamSelectionTime: isReadyForSelection(events) ? formatLocalDateTime(getNationalTeamSelectionTime(events, user)) : 'n/a'
                }
              })}
              rowMetadata={[
                { columnName: 'name', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                { columnName: 'acronym', columnDescription: 'Acr.' },
                browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                  { columnName: 'countryFlag', columnDescription: '\u2691' }
                  :
                  { columnName: 'countryFlagC4FCode', columnDescription: '\u2691', columnType: 'flag' },
                { columnName: 'country', columnDescription: 'CountryCode' },
                { columnName: 'forumAccount', columnDescription: 'Forum' },
                { columnName: 'fairnessVotes', columnDescription: '\u221E Fairness' },
                { columnName: 'nationalTeamName', columnDescription: 'National Team' },
                { columnName: 'roles', columnDescription: 'Roles' }
              ].concat(isReadyForSelection(events) ? 
                [
                  { columnName: 'nationalTeamSelectionRank', columnDescription: 'Selection Rank' },
                  { columnName: 'nationalTeamSelectionTime', columnDescription: 'Selection From' }
                ] : [])
              }
            />
          </div>
        </div>
      
      if (tab === 'countries')
        return <Container fluid className="c4f-stats">
          <Row className="d-flex c4f-stats">
            <Col className="m-0 p-0">
              <h5>Countries</h5>
            </Col>
          </Row>
          <Row className="d-flex c4f-stats">
            <Col className="m-0 p-0">
            <C4FSimpleTable key={'countries'}
              initialSortingColumn={'pointsCurrentTotal'}
              initialSortingAscending={false}
              indexColumn={true}
              refreshTable={() => loadStatistics('countries')}
              data={countryStatistics.map(country => ({ 
                ...country, 
                name: getCountryName(countries, country.countryCode),
                flag: getUnicodeFlag(country.countryCode),
                nationalityC4FCode: getC4FCodeForCountryCode(countries, country.countryCode),
                ncJersey: <img alt={'NC_' + country.countryCode} title={'NC_' + country.countryCode} src={getJersey('', 'NC_' + country.countryCode)} style={{ maxHeight: "18px" }} />,
                owner: 'None'
              }))}
              rowMetadata={[
                browserInfo && browserInfo.browserSupportsUnicodeFlags ?
                  { columnName: 'flag', columnDescription: '\u2691' }
                  :
                  { columnName: 'nationalityC4FCode', columnDescription: '\u2691', columnType: 'flag', columnGroup: 'Overview' },
                { columnName: 'name', columnDescription: 'Country', cellClickEvent: showTeamInfo },
                { columnName: 'countryCode', columnDescription: 'Code' },
                { columnName: 'ncJersey', columnDescription: 'Jersey', columnType: 'object' },
                { columnName: 'ownerName', columnDescription: 'Coach' },
                { columnName: 'totalRiders', columnDescription: 'Riders' },
                { columnName: 'totalRidersRetired', columnDescription: 'Ex-Riders' },
                { columnName: 'pointsCurrentTotal', columnDescription: 'Points' },
                { columnName: 'pointsEternalTotal', columnDescription: 'Points \u221E' },
                { columnName: 'pointsCurrentAverage', columnDescription: '\u2300 Points' },
                { columnName: 'pointsEternalAverage', columnDescription: '\u2300 Points \u221E' },
                { columnName: 'goldMedals', columnDescription: '\uD83E\uDD47' },
                { columnName: 'silverMedals', columnDescription: '\uD83E\uDD48' },
                { columnName: 'bronzeMedals', columnDescription: '\uD83E\uDD49' }
              ]}
            />
            </Col>
          </Row>
        </Container>
      
      if (tab === 'transfers')
        return <div className="container-fluid c4f-stats">
          <div className="row d-flex c4f-stats">
            <div className="col m-0 p-0">
              <h5>Transfers</h5>
              <p>The table shows all transfers.&nbsp;
                {transfersInfo}.&nbsp;
                {transfersComplete ?
                  null :
                  <>
                    {/* <ButtonGroup> */}
                    <Button className="py-0" variant="outline-primary" onClick={() => { loadStatistics('transfers', 2000); setTransfersComplete(true); }}>Load more records</Button>
                    {/* </ButtonGroup> */}
                    {/* <br />Please keep in mind that loading all records might lead to performance issues on your browser. */}
                  </>
                }
              </p>
            </div>
          </div>
          <div className="row d-flex c4f-stats">
            <C4FSimpleTable key={'transfers'}
              highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
              highlightCriteriaValue={userInformation !== null ? getRegularTeam(userInformation).teamName : null}
              initialSortingColumn={'transferId'}
              initialSortingAscending={false}
              data={transfers}
              rowMetadata={[
                { columnName: 'date', columnDescription: 'Date' },
                { columnName: 'transferType', columnDescription: 'Type' },
                { columnName: 'riderName', columnDescription: 'Rider', cellClickEvent: showRiderInfo },
                { columnName: 'teamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                { columnName: 'price', columnDescription: 'Price', columnType: 'currency' }
              ]}
            />
          </div>
        </div>
      if (tab === 'splitStats')
        return <Container className="c4f-stats">
          <Row className="c4f-stats ">
            <h5>Stats Galore</h5>
            <p>The table shows details of wins per year (excluding today's races and open tours). At the moment, it includes wins per category and per number of other teams, which finished the race. This will be extended soon with other statistics. Feel free to discuss in the forum on what could be added here (if required data is available)</p>
            <Row className="c4f-stats m-0 p-0 justify-content-center">
              <Col className={'col-2 mx-1'}>
                <ButtonGroup>
                  <Button variant={(splitStatsScope === 'Teams') ? 'primary' : 'outline-primary'} onClick={() => handleSplitStats('Teams', splitStatsType)}>Teams</Button>
                  <Button variant={(splitStatsScope === 'Riders') ? 'primary' : 'outline-primary'} onClick={() => handleSplitStats('Riders', splitStatsType)}>Riders</Button>
                </ButtonGroup>
              </Col>
              <Col className={'col-3 mx-1'}>
                <ButtonGroup>
                  <Button variant={(splitStatsType === 'Wins') ? 'primary' : 'outline-primary'} onClick={() => handleSplitStats(splitStatsScope, 'Wins')}>Race Wins</Button>
                  <Button variant={(splitStatsType === 'TourWins') ? 'primary' : 'outline-primary'} onClick={() => handleSplitStats(splitStatsScope, 'TourWins')}>Tour Wins</Button>
                  <Button disabled variant={(splitStatsType === 'Races') ? 'primary' : 'outline-primary'} onClick={() => handleSplitStats(splitStatsScope, 'Races')}>Races</Button>
                </ButtonGroup>
              </Col>
              <Col className={'col-6 m-1'}>
                <InputGroup className="">
                  <DropdownButton variant={'outline-secondary'}
                    title={dateFrom.substring(0, 4)}
                    onSelect={(year, e) => { setDateFrom(year + '-01-01'); setDateTo(year + '-12-31'); }}>
                    {['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026'].map(year =>
                      <Dropdown.Item eventKey={year}>{year}</Dropdown.Item>
                    )}
                  </DropdownButton>
                  <Form.Control type={'date'}
                    onChange={(e) => setDateFrom(e.target.value)}
                    value={dateFrom} />
                  <Form.Control type={'date'}
                    onChange={(e) => setDateTo(e.target.value)}
                    value={dateTo} />
                  <Button variant={'success'} onClick={() => handleSplitStats(splitStatsScope, splitStatsType)}>{'Refresh \u21BB'}</Button>
                </InputGroup>
              </Col>
            </Row>
            {splitStats.some(stats => stats.type.startsWith(splitStatsScope + splitStatsType)) ?
              <>
                {splitStatsScope === 'Teams' && splitStatsType === 'Wins' ?
                  <C4FSimpleTable key={'splitStats' + splitStatsScope + splitStatsType}
                    description="Split Stats for Wins of Teams"
                    highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
                    highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
                    initialSortingColumn={'teamName'}
                    initialSortingAscending={true}
                    indexColumn={true}
                    data={splitStats.find(stats => stats.type.startsWith(splitStatsScope + splitStatsType)).data}
                    rowMetadata={[
                      { columnName: 'teamName', columnDescription: 'Team', columnGroup: 'Overview', cellClickEvent: showTeamInfo },
                      { columnName: 'totalWins', columnDescription: '\u03A3 Wins', columnGroup: 'Overview' },
                      { columnName: 'totalStageWins', columnDescription: '\u03A3 Stages', columnGroup: 'Overview' },
                      { columnName: 'category', columnDescription: '\u2300 Category', columnGroup: 'Overview' },
                      { columnName: 'opponents', columnDescription: '\u2300 Opponents', columnGroup: 'Overview' },
                      { columnName: 'totalCat1', columnDescription: '1', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat2', columnDescription: '2', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat3', columnDescription: '3', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat4', columnDescription: '4', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat5', columnDescription: '5', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat6', columnDescription: '6', columnGroup: 'Wins / Category' },
                      { columnName: 'opponents0', columnDescription: '0', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents1', columnDescription: '1', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents2', columnDescription: '2', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents3', columnDescription: '3', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents4', columnDescription: '4', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents5', columnDescription: '5', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents6', columnDescription: '6', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents7', columnDescription: '7', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents8', columnDescription: '8', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents9', columnDescription: '9', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents10Plus', columnDescription: '10+', columnGroup: 'Wins / # Opponents' }
                    ]}
                  /> : null}
                {splitStatsScope === 'Teams' && splitStatsType === 'TourWins' ?
                  <C4FSimpleTable key={'splitStats' + splitStatsScope + splitStatsType}
                    description="Split Stats for Tour Wins of Teams"
                    highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
                    highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
                    initialSortingColumn={'teamName'}
                    initialSortingAscending={true}
                    indexColumn={true}
                    data={splitStats.find(stats => stats.type.startsWith(splitStatsScope + splitStatsType)).data}
                    rowMetadata={[
                      { columnName: 'teamName', columnDescription: 'Team', columnGroup: 'Overview', cellClickEvent: showTeamInfo },
                      { columnName: 'totalWins', columnDescription: '\u03A3 Wins', columnGroup: 'Overview' },
                      { columnName: 'category', columnDescription: '\u2300 Cat', columnGroup: 'Overview' },
                      { columnName: 'startingTime', columnDescription: '\u2300 Time', columnGroup: 'Overview' },
                      { columnName: 'totalStages', columnDescription: '\u03A3 Stages', columnGroup: 'Race Details' },
                      { columnName: 'avgStages', columnDescription: '\u2300 Stages', columnGroup: 'Race Details' },
                      { columnName: 'totalLength', columnDescription: '\u03A3 Length', columnGroup: 'Race Details' },
                      { columnName: 'avgLength', columnDescription: '\u2300 Length', columnGroup: 'Race Details' },
                      { columnName: 'totalClimbs', columnDescription: '\u03A3 Climbs', columnGroup: 'Race Details' },
                      { columnName: 'avgClimbs', columnDescription: '\u2300 Climbs', columnGroup: 'Race Details' },
                      { columnName: 'totalCat1', columnDescription: '1', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat2', columnDescription: '2', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat3', columnDescription: '3', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat4', columnDescription: '4', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat5', columnDescription: '5', columnGroup: 'Wins / Category' }
                    ]}
                  /> : null}
                {splitStatsScope === 'Teams' && splitStatsType === 'Races' ?
                  null : null}
                {splitStatsScope === 'Riders' && splitStatsType === 'Wins' ?
                  <C4FSimpleTable key={'splitStats' + splitStatsScope + splitStatsType}
                    description="Split Stats for Wins of Riders"
                    highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
                    highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
                    initialSortingColumn={'riderName'}
                    initialSortingAscending={true}
                    indexColumn={true}
                    data={splitStats.find(stats => stats.type.startsWith(splitStatsScope + splitStatsType)).data}
                    rowMetadata={[
                      { columnName: 'riderName', columnDescription: 'Rider', columnGroup: 'Overview', cellClickEvent: showRiderInfo },
                      { columnName: 'teamName', columnDescription: 'Team', columnGroup: 'Overview', cellClickEvent: showTeamInfo },
                      { columnName: 'totalWins', columnDescription: '\u03A3 Wins', columnGroup: 'Overview' },
                      { columnName: 'totalStageWins', columnDescription: '\u03A3 Stages', columnGroup: 'Overview' },
                      { columnName: 'category', columnDescription: '\u2300 Category', columnGroup: 'Overview' },
                      { columnName: 'opponents', columnDescription: '\u2300 Opponents', columnGroup: 'Overview' },
                      { columnName: 'totalCat1', columnDescription: '1', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat2', columnDescription: '2', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat3', columnDescription: '3', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat4', columnDescription: '4', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat5', columnDescription: '5', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat6', columnDescription: '6', columnGroup: 'Wins / Category' },
                      { columnName: 'opponents0', columnDescription: '0', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents1', columnDescription: '1', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents2', columnDescription: '2', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents3', columnDescription: '3', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents4', columnDescription: '4', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents5', columnDescription: '5', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents6', columnDescription: '6', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents7', columnDescription: '7', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents8', columnDescription: '8', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents9', columnDescription: '9', columnGroup: 'Wins / # Opponents' },
                      { columnName: 'opponents10Plus', columnDescription: '10+', columnGroup: 'Wins / # Opponents' }
                    ]}
                  /> : null}
                {splitStatsScope === 'Riders' && splitStatsType === 'TourWins' ?
                  <C4FSimpleTable key={'splitStats' + splitStatsScope + splitStatsType}
                    description="Split Stats for Tour Wins of Riders"
                    highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
                    highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
                    initialSortingColumn={'riderName'}
                    initialSortingAscending={true}
                    indexColumn={true}
                    data={splitStats.find(stats => stats.type.startsWith(splitStatsScope + splitStatsType)).data}
                    rowMetadata={[
                      { columnName: 'riderName', columnDescription: 'Rider', columnGroup: 'Overview', cellClickEvent: showRiderInfo },
                      { columnName: 'teamName', columnDescription: 'Team', columnGroup: 'Overview', cellClickEvent: showTeamInfo },
                      { columnName: 'totalWins', columnDescription: '\u03A3 Wins', columnGroup: 'Overview' },
                      { columnName: 'category', columnDescription: '\u2300 Category', columnGroup: 'Overview' },
                      { columnName: 'startingTime', columnDescription: '\u2300 Time', columnGroup: 'Overview' },
                      { columnName: 'totalStages', columnDescription: '\u03A3 Stages', columnGroup: 'Race Details' },
                      { columnName: 'avgStages', columnDescription: '\u2300 Stages', columnGroup: 'Race Details' },
                      { columnName: 'totalLength', columnDescription: '\u03A3 Length', columnGroup: 'Race Details' },
                      { columnName: 'avgLength', columnDescription: '\u2300 Length', columnGroup: 'Race Details' },
                      { columnName: 'totalClimbs', columnDescription: '\u03A3 Climbs', columnGroup: 'Race Details' },
                      { columnName: 'avgClimbs', columnDescription: '\u2300 Climbs', columnGroup: 'Race Details' },
                      { columnName: 'totalCat1', columnDescription: '1', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat2', columnDescription: '2', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat3', columnDescription: '3', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat4', columnDescription: '4', columnGroup: 'Wins / Category' },
                      { columnName: 'totalCat5', columnDescription: '5', columnGroup: 'Wins / Category' }
                    ]}
                  /> : null}
                {splitStatsScope === 'Riders' && splitStatsType === 'Races' ?
                  null : null}
              </> : null}
          </Row>
        </Container>
      if (tab === 'hallOfFame')
        return <div className="container-fluid c4f-stats">
          <Row className="c4f-stats">
            <Col className="m-0 p-0">
              <h5>Hall of Fame</h5>
              <p>All winners of Monuments and Grand Tours.</p>
            </Col>
          </Row>
          <Row className="c4f-stats m-0 p-0 justify-content-center">
            <ButtonGroup>
              <Button variant={(subTab === 'all') ? 'primary' : 'outline-primary'} onClick={() => handleSubTab('all')}>All Entries</Button>
              <Button variant={(subTab === 'perTeam') ? 'primary' : 'outline-primary'} onClick={() => handleSubTab('perTeam')}>Per Team</Button>
            </ButtonGroup>
          </Row>
          <Row className="c4f-stats ">
            {subTab === 'all' ?
              <>
                <h5>All Entries</h5>
                <C4FSimpleTable key={'hallOfFame'}
                  initialSortingColumn={'date'}
                  initialSortingAscending={false}
                  data={hallOfFame}
                  highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
                  highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
                  rowMetadata={[
                    { columnName: 'riderName', columnDescription: 'Rider', cellClickEvent: showRiderInfo },
                    { columnName: 'teamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                    { columnName: 'raceName', columnDescription: 'Race' },
                    { columnName: 'date', columnDescription: 'Date' }
                  ]}
                />
              </>
              : null}
            {subTab === 'perTeam' ?
              <>
                <h5>Totals</h5>
                <C4FSimpleTable key={'hofTeamStatistics'}
                  initialSortingColumn={'total'}
                  initialSortingAscending={false}
                  indexColumn={true}
                  data={hofTeamStatistics}
                  highlightCriteriaKey={userInformation !== null ? 'teamNames' : null}
                  highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
                  rowMetadata={[
                    { columnName: 'teamNames', columnDescription: 'Team' },
                    { columnName: 'total', columnDescription: 'Total' },
                    { columnName: 'totalGTs', columnDescription: 'GTs' },
                    { columnName: 'totalMonuments', columnDescription: 'Mon' },
                    { columnName: 'giro', columnDescription: 'Giro' },
                    { columnName: 'tour', columnDescription: 'Tour' },
                    { columnName: 'vuelta', columnDescription: 'Vuelta' },
                    { columnName: 'msr', columnDescription: 'MSR' },
                    { columnName: 'rvv', columnDescription: 'RVV' },
                    { columnName: 'pr', columnDescription: 'PR' },
                    { columnName: 'lbl', columnDescription: 'LBL' },
                    { columnName: 'lom', columnDescription: 'Lom' }
                  ]}
                />
              </>
              : null}
          </Row>
        </div>
      if (tab === 'raceSeries')
        return <Container className="c4f-stats">
          <Row className="c4f-stats">
            <Col className="m-0 p-0">
              <h5>Race Series</h5>
              <p>User-defined race series (like UCI World Tour). Feel free to suggest other race series (e.g. winter classics) and the results can be shown here automatically. The points in the rankings are based on the race results, the weighted rankings take the number of teams in a race into consideration as well (points * (teams - 1) / 10)</p>
            </Col>
          </Row>
          <Row className="c4f-stats justify-content-center">
            <Col className="m-0 p-1 text-center">
              <ButtonGroup>
                <Button variant={(subTab === 'overview') ? 'primary' : 'outline-primary'} onClick={() => handleSubTab('overview')}>Overview</Button>
                {raceSeries !== null ?
                  <>
                    <Button variant={(subTab === 'details') ? 'primary' : 'outline-primary'} onClick={() => handleSubTab('details')}>Details</Button>
                    <Button variant={(subTab === 'rules') ? 'primary' : 'outline-primary'} onClick={() => handleSubTab('rules')}>Rules</Button>
                  </>
                  :
                  <>
                    <Button variant={(subTab === 'details') ? 'primary' : 'outline-primary'} disabled>Details</Button>
                    <Button variant={(subTab === 'rules') ? 'primary' : 'outline-primary'} disabled>Rules</Button>
                  </>
                }
              </ButtonGroup>
            </Col>
          </Row>
          {subTab === 'overview' ?
            <>
              <Row className="c4f-stats h-25">
                <Col className="col-6">
                  <h5>All Race Series</h5>
                  <p>click on name to load details</p>
                  <C4FSimpleTable key={'raceSeriesList'}
                    highlightCriteriaKey={'id'}
                    highlightCriteriaValue={selectedRaceSeries}
                    initialSortingColumn={'name'}
                    initialSortingAscending={true}
                    hideFilterButtons={true}
                    data={raceSeriesList}
                    rowMetadata={[
                      { columnName: 'name', columnDescription: 'Name', cellClickEvent: loadRaceSeries },
                      { columnName: 'description', columnDescription: 'Description' }
                    ]}
                  />
                </Col>
              </Row>
              {raceSeries !== null ?
                <Row className="c4f-stats h-25">
                  <Col className="col-6">
                    <h5>Rider Ranking</h5>
                    <C4FSimpleTable key={'raceSeriesRiderResults'}
                      highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
                      highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
                      initialSortingColumn={'pointsWeighted'}
                      initialSortingAscending={false}
                      hideColumnVisibility={true}
                      indexColumn={true}
                      data={raceSeriesRiderResults}
                      rowMetadata={[
                        { columnName: 'riderName', columnDescription: 'Rider', cellClickEvent: showRiderInfo },
                        { columnName: 'teamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                        { columnName: 'points', columnDescription: '\u03A3 Pts' },
                        { columnName: 'pointsWeighted', columnDescription: '\u03A3 Weighted' },
                        { columnName: 'raceWins', columnDescription: '\uD83C\uDFC6' },
                        { columnName: 'tourWins', columnDescription: '\u03A3 Tours', columnHeader: <><img alt="GCLeader" title="Stage Race Wins" src={getJersey('Le Tour', 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} /></> }
                      ]}
                    />
                  </Col>
                  <Col className="col-6">
                    <h5>Team Ranking</h5>
                    <C4FSimpleTable key={'raceSeriesTeamResults'}
                      highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
                      highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
                      initialSortingColumn={'pointsWeighted'}
                      initialSortingAscending={false}
                      hideColumnVisibility={true}
                      indexColumn={true}
                      data={raceSeriesTeamResults}
                      rowMetadata={[
                        { columnName: 'teamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                        { columnName: 'points', columnDescription: '\u03A3 Pts' },
                        { columnName: 'pointsWeighted', columnDescription: '\u03A3 Weighted' },
                        { columnName: 'raceWins', columnDescription: '\uD83C\uDFC6' },
                        { columnName: 'tourWins', columnDescription: '\u03A3 Tours', columnHeader: <><img alt="GCLeader" title="Stage Race Wins" src={getJersey('Le Tour', 'GCLeader')} style={{ maxHeight: "18px", marginBottom: 1 }} /></> }
                      ]}
                    />
                  </Col>
                </Row>
                : null}
            </>
            : null}
          {subTab === 'details' ?
            <Row className="c4f-stats">
              <h5>Detailed Results</h5>
              <C4FSimpleTable key={'raceSeriesResults'}
                highlightCriteriaKey={userInformation !== null ? 'teamName' : null}
                highlightCriteriaValue={userInformation !== null ? userInformation.userName : null}
                data={raceSeriesResultList}
                rowMetadata={[
                  { columnName: 'raceName', columnDescription: 'Race' },
                  { columnName: 'startingTime', columnDescription: 'Time' },
                  { columnName: 'resultType', columnDescription: 'Type' },
                  { columnName: 'position', columnDescription: 'Pos' },
                  { columnName: 'riderName', columnDescription: 'Rider', cellClickEvent: showRiderInfo },
                  { columnName: 'teamName', columnDescription: 'Team', cellClickEvent: showTeamInfo },
                  { columnName: 'points', columnDescription: 'Points' },
                  { columnName: 'teamsFinished', columnDescription: 'Teams' },
                  { columnName: 'pointsWeighted', columnDescription: 'Weighted' }
                ]}
              />
            </Row>
            : null}
          {subTab === 'rules' && raceSeries !== null ?
            <Row className="c4f-stats">
              <Col className="col-6">
                <h5>Included Races</h5>
                <C4FSimpleTable key={'raceSeriesRaces'}
                  initialSortingColumn={'raceEditionId'}
                  initialSortingAscending={true}
                  hideFilterButtons={true}
                  data={raceSeries.raceSeriesItems}
                  rowMetadata={[
                    { columnName: 'raceName', columnDescription: 'Name' },
                    { columnName: 'startingDate', columnDescription: 'Date' },
                    { columnName: 'startingTime', columnDescription: 'Time' },
                    { columnName: 'ruleId', columnDescription: 'Rule' }
                  ]}
                />
              </Col>
              <Col className="col-6">
                <h5>Rules</h5>
                <C4FSimpleTable key={'raceSeriesRules'}
                  initialSortingColumn={'raceEditionId'}
                  initialSortingAscending={true}
                  hideFilterButtons={true}
                  data={raceSeriesRules}
                  rowMetadata={[
                    { columnName: 'ruleId', columnDescription: 'Rule' },
                    { columnName: 'resultType', columnDescription: 'Type' },
                    { columnName: 'position', columnDescription: 'Pos' },
                    { columnName: 'points', columnDescription: 'Points' }
                  ]}
                />
              </Col>
            </Row>
            : null}
        </Container>

    })()
    }
    <div className="row d-flex p-0 m-1 justify-content-center">
      <div className="col" style={{ textAlign: "center" }}>
        <br />
        <br />
        <br />
        <br />
        <br />
        <p>Visit the <a href={config.FORUM_BASE_URL} target="_blank" rel="noreferrer">Forum</a> to find more statistics.</p>
        <br />
        <br />
        <br />
      </div>
    </div>
  </div >;

}
export default Statistics;